module.exports = __webpack_public_path__ + "713df4a98683bbbc9e0decd3fc9c0cf7.woff2";